// Guest prescriptions are stored with IDs of the form `guest_<Date.now()>`.
// We prune any guest entry older than this TTL on every page load so a
// returning visitor (or a shared device) doesn't see stale prescriptions
// in the saved-Rx list. Account prescriptions (`C*` IDs) are unaffected
// since they are server-authoritative and reloaded from the API.
const GUEST_RX_TTL_MS = 4 * 60 * 60 * 1000; // 4 hours

class CartPrescriptions {
  constructor() {
    const localStorageKey = 'cartPrescriptions'
    this.prescriptions = []

    try {
      this.prescriptions = JSON.parse(localStorage.getItem(localStorageKey)) || []
    } catch(error) {
      localStorage.removeItem(localStorageKey)
      console.error(error)
    }

    this.pruneExpiredGuestPrescriptions()
  }

  // Drop guest entries whose timestamp (encoded in `guest_<Date.now()>`) is
  // older than GUEST_RX_TTL_MS. Malformed/un-parseable guest IDs are also
  // dropped defensively. Account entries (id starting with 'C') are kept.
  pruneExpiredGuestPrescriptions() {
    const now = Date.now()
    const before = this.prescriptions.length

    this.prescriptions = this.prescriptions.filter(rx => {
      if (typeof rx?.id !== 'string' || !rx.id.startsWith('guest_')) return true
      const ts = parseInt(rx.id.slice('guest_'.length), 10)
      if (!Number.isFinite(ts)) return false
      return (now - ts) < GUEST_RX_TTL_MS
    })

    if (this.prescriptions.length !== before) {
      this.save()
      console.log(`[cartPrescriptions] Pruned ${before - this.prescriptions.length} expired guest Rx entr${before - this.prescriptions.length === 1 ? 'y' : 'ies'}.`)
    }
  }

  addPrescription(prescriptionId, prescription, productType) {
    const existingPrescription = this.prescriptions.find(rx => rx.id === prescriptionId)
    if (existingPrescription) { return }

    const productTypeRxKeys = {
      'Frames': 'spectaclePrescription',
      'Contact Lenses': 'lensPrescription'
    }

    this.prescriptions.push({
      id: prescriptionId,
      [productTypeRxKeys[productType]]: prescription
    })

    this.save()
  }

  save() {
    localStorage.setItem('cartPrescriptions', JSON.stringify(this.prescriptions))
  }

  async deleteOldPrescriptions() {
    this.prescriptions = this.prescriptions
      .filter(rx => rx.lineItemsApplied.length === 0)
    
    this.save()
  }
}

window.cartPrescriptions = new CartPrescriptions()